import { SetStateAction, useEffect, useState, Dispatch } from 'react';
import { pbLog } from '../utils/log';
import {
  fetchCourierById,
  fetchCourierByIdList,
  fetchMyCourierUser,
} from 'fetch/fetchUsers';
import { ReqEnum } from 'const/requestStatus';

import { reqStatus } from 'types/orderTypes';
import { User } from 'types/userTypes';
import { CourierJson } from '../types/bundleTypes';

const log = pbLog('containers:UsersFetch');
const RESET_STATE_MSG = 'Reset state';
const FETCHING_USER_MSG = 'Fetching my user';
const FETCHED_USER_MSG = 'Fetched my user';

function initFetch(setFetchStatus: Dispatch<SetStateAction<reqStatus>>) {
  log(RESET_STATE_MSG);
  setFetchStatus(ReqEnum.PENDING);
  log(FETCHING_USER_MSG);
}

function fetchUsers(
  setFetchStatus: Dispatch<SetStateAction<reqStatus>>,
  setMyUser: Dispatch<SetStateAction<User>>,
  courierId?: number
) {
  initFetch(setFetchStatus);
  const fetchUsersMethod = async () => {
    const myUser = courierId
      ? await fetchCourierById(courierId)
      : await fetchMyCourierUser();
    log(FETCHED_USER_MSG, myUser);

    setMyUser(myUser);
    setFetchStatus(ReqEnum.SUCCESS);
  };

  return fetchUsersMethod;
}

export function useFetchMyCourierUser(): any[] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [myUser, setMyUser] = useState<User>();

  useEffect(() => {
    const fetchUsersMethod = fetchUsers(setFetchStatus, setMyUser);
    fetchUsersMethod();
  }, []);

  return [myUser, fetchStatus];
}

export function useFetchCourierUserById(courierId: number): any[] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [myUser, setMyUser] = useState<User>();

  useEffect(() => {
    const fetchUsersMethod = fetchUsers(setFetchStatus, setMyUser, courierId);
    if (courierId > 0) fetchUsersMethod();
  }, [courierId]);

  return [myUser, fetchStatus];
}

export function useFetchCourierUserListByCourierIdList(
  courierIdList: number[]
): any[] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [myUserList, setMyUserList] = useState<{
    [courierId: string]: CourierJson;
  }>();

  useEffect(() => {
    initFetch(setFetchStatus);
    const fetchUsersMethod = async () => {
      const myUserList: {
        [courierId: string]: CourierJson;
      } = await fetchCourierByIdList(courierIdList);
      log(FETCHED_USER_MSG, myUserList);

      setMyUserList(myUserList);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    if (courierIdList.length > 0) fetchUsersMethod();
  }, [courierIdList]);

  return [myUserList, fetchStatus];
}
